<!--<div id="container">-->
<nav>
  <ul class="{{menuPosition}}" *ngIf="items?.length > 0" app-generic-menu-item [menuPosition]="menuPosition" [iconsPath]="iconsPath" [isFirstLevel]="true" [items]="items"></ul>
</nav>
<!--</div>-->
